var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cinput type=\"range\" [min]=\"min\" [max]=\"max\" [step]=\"step\" [(ngModel)]=\"valueModel\" (ngModelChange)=\"valueModelChange.emit(valueModel)\" [disabled]=\"disabled\"\u003E";;return pug_html;};
module.exports = template;